import { SectionView } from "../components/templates/SectionView.tsx";
import { RitualList } from "../components/organisms/RitualList.tsx";
import { SubscribeRitual } from "../components/molecules/SubscribeRitual.tsx";
import { SubscribeForm } from "../components/molecules/SubscribeForm.tsx";

export function RitualPage() {
  return (
    <SectionView
      ariaLabel="Ritual"
      title="The Ritual"
      sub="Weekly notes — what I'm building, thinking, and learning in public. Tap an entry to unfold it."
    >
      <SubscribeForm />
      <SubscribeRitual />
      <RitualList />
    </SectionView>
  );
}
